import { ChartOptions } from 'chart.js';
import { DS_CHART_DEFAULT_TOOLTIP_OPTIONS } from './ds-chart-default-tooltip-options.constant';

export const DS_CHARTS_DEFAULT_OPTIONS: ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    labels: {},
    align: 'end',
  },
  scales: {
    xAxes: [],
    yAxes: [],
  },
  tooltips: DS_CHART_DEFAULT_TOOLTIP_OPTIONS,
};
